import { useParams, useNavigate } from "react-router-dom";
import routes from "@/routes";

import { Table, Tooltip, Typography } from "antd";

import CustomLink from "@/components/ui/CustomLink";
import ContextMenu from "@/components/containers/ContextMenu";
import CheckIcon from "@/icons/CheckIcon";

const { Text } = Typography;

// Таблица объектов
const DefinitionsTable = ({
  data,
  pagination,
  loading,
  onChange,
  onEditItem,
  onDeleteItem,
  scroll = { x: "100%" },
}) => {
  const { type } = useParams();

  const navigate = useNavigate();

  const columns = [
    {
      title: "Название",
      dataIndex: "name",
      width: 250,
      defaultSortOrder: "ascend",
      sorter: {
        compare: (a, b) => a.name.localeCompare(b.name),
        multiple: 1,
      },
      render: (name, { uuid }) => (
        <CustomLink
          to={routes.administration.resourcesSettings.structures.definitionDetail(
            type,
            uuid,
          )}
        >
          {name}
        </CustomLink>
      ),
    },
    {
      title: "Описание",
      dataIndex: "description",
      key: "description",
      ellipsis: true,
      width: 400,
      render: (description) =>
        description ? (
          <Tooltip title={description}>
            <Text
              style={{
                display: "inline-block",
              }}
              ellipsis
            >
              {description}
            </Text>
          </Tooltip>
        ) : (
          <></>
        ),
    },
    ...(type === "objects"
      ? [
          {
            title: "Расширенный доступ",
            dataIndex: "use_permission_rules",
            key: "use_permission_rules",
            width: 170,
            align: "center",
            render: (usePermissionRules) =>
              usePermissionRules && (
                <CheckIcon
                  style={{
                    fontSize: 18,
                    color: "#BBBBBB",
                    verticalAlign: "middle",
                  }}
                />
              ),
          },
        ]
      : []),
    ...(type !== "templates"
      ? [
          {
            title: "Актуализация из НСПД",
            dataIndex: "is_nspd_enabled",
            key: "is_nspd_enabled",
            width: 180,
            align: "center",
            render: (isNspdEnabled) =>
              isNspdEnabled && (
                <CheckIcon
                  style={{
                    fontSize: 18,
                    color: "#BBBBBB",
                    verticalAlign: "middle",
                  }}
                />
              ),
          },
          {
            title: "Категория НСПД",
            dataIndex: "nspd_category",
            width: 200,
            defaultSortOrder: "ascend",
            render: (_, { nspd_category }) =>
              nspd_category ? (
                <Text
                  style={{
                    display: "inline-block",
                  }}
                  ellipsis
                >
                  {nspd_category.name}
                </Text>
              ) : (
                <></>
              ),
          },
        ]
      : []),
    {
      title: "",
      width: 48,
      align: "center",
      fixed: "right",
      key: "actions",
      render: (_, item) => (
        <ContextMenu
          vertical
          onView={() =>
            navigate(
              routes.administration.resourcesSettings.structures.definitionDetail(
                type,
                item.uuid,
              ),
            )
          }
          onEdit={() => onEditItem(item)}
          onDelete={() => onDeleteItem(item)}
        />
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      columns={columns}
      rowKey="uuid"
      loading={loading}
      pagination={pagination}
      onChange={onChange}
      showSorterTooltip={{
        target: "sorter-icon",
        title: "Нажмите для сортировки",
      }}
      scroll={scroll}
    />
  );
};

export default DefinitionsTable;
